import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from 'react-oidc-context';
import { TARGET_DESTINATION } from '@legacy/constants/localstorage';

const getLoginCallBackPath = (
  accessToken?: string,
  storedTargetDestination?: string | null,
): string | null => {
  if (accessToken) {
    if (storedTargetDestination) {
      return storedTargetDestination;
    }
  }

  return null;
};

export const getRedirectPathForTest = getLoginCallBackPath;

export const LoginCallbackRedirection = () => {
  const { user } = useAuth();
  const accessToken = user?.access_token;
  const storedTargetDestination = localStorage.getItem(TARGET_DESTINATION);
  const navigate = useNavigate();
  const result = getLoginCallBackPath(accessToken, storedTargetDestination);
  useEffect(() => {
    if (result) {
      localStorage.removeItem(TARGET_DESTINATION);
      navigate(result);
    }
  }, [result, navigate]);

  return null;
};
